if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// SLICK DEFAULTS
const prevArrow = `<button type="button" class="slick-prev slick-arrow"><span>Prev</span><svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="48.23" height="31.047" viewBox="0 0 48.23 31.047"><g transform="translate(-37 -43.933)"><path data-name="Shape 3 copy 2" d="M73.335,44.554,84,58,73.335,74.436" fill="none" stroke="#fff" stroke-width="2"/><line data-name="Shape 2" x2="46" transform="translate(37 58)" fill="none" stroke="#fff" stroke-width="2"/></g></svg><svg class="circle" height="40" width="40"><circle cx="50%" cy="50%" r="30" stroke="#b86545" stroke-width="1" fill="none"></circle></svg></button>`;
const nextArrow = `<button type="button" class="slick-next slick-arrow"><span>Next</span><svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="48.23" height="31.047" viewBox="0 0 48.23 31.047"><g transform="translate(-37 -43.933)"><path data-name="Shape 3 copy 2" d="M73.335,44.554,84,58,73.335,74.436" fill="none" stroke="#fff" stroke-width="2"/><line data-name="Shape 2" x2="46" transform="translate(37 58)" fill="none" stroke="#fff" stroke-width="2"/></g></svg><svg class="circle" height="40" width="40"><circle cx="50%" cy="50%" r="30" stroke="#b86545" stroke-width="1" fill="none"></circle></svg></button>`;
const slickOps = {
    accessibility: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow
};

// Slick Slider with current slide number
const setSlickShowIndex = ( selector = '[data-slick_showIndex]' ) => {
    $(selector).each((i, el) => {
        let currentIndex = '1';
        $(el).on('init', (e, s)=> {
            let slideCount = s.slideCount;
            if ( s.options.arrows ) {
                $(s.options.appendDots).append(`<div class="slick-current_index"><span class="large">${currentIndex}</span>/<span class="small">${slideCount}</span></div>`);
            }
        });

        $(el).on('beforeChange', (e, s, c, n)=> {
            currentIndex = (`${(n+1)}`).slice(-2);
            if ( s.options.arrows ) {
                $('.slick-current_index span.large', s.options.appendDots).text(currentIndex);
            }

            if( s.options.autoplay ) {
                $('.slick-current_index', s.options.appendDots).removeClass('inprogress');
                setTimeout(() => $('.slick-current_index', s.options.appendDots).addClass('inprogress'), 10);
            }
        });
    });
};

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    // Slick Slider with current slide number
    setSlickShowIndex();
    
    // SLIDERS
    $('.sym-slides').slick({
        accessibility: false
    });
    
    // slider Reviews
    $('.sym-slides-reviews').slick({
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 300,
        accessibility: true,
        arrows: true,
    });

    //List slide
    $('.sym-slider-list').slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        fade:true
    });

    // single slider
    $('.sym-slider-block').slick( {
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        appendDots: '.slider-block__controls',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    // slider Gallery 
    $('.gallery-slides').slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        infinite: false,
        fade: false,
        speed: 1000,
        slidesToShow: 2,
        variableWidth: true,
        initialSlide: 1,
    });

    // Slide gallery
    $('.gallery--left').slick({
        lazyLoad: 'progressive',
        fade: false,
        cssEase: 'linear',
        arrows: false,
        dots: false,
        asNavFor: '.gallery--right',
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    adaptiveHeight: true,
                    autoplay: true,
                }
            }
        ]

    })
    $('.gallery--right').slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        cssEase: 'linear',
        arrows: true,
        dots: false,
        slidesToShow: 3,
        variableWidth: true,
        lazyLoad: 'progressive',
        autoplay: true,
        autoplaySpeed: 2000,
        asNavFor: '.gallery--left',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    autoplay: true,
                    adaptiveHeight: true,
                    centerMode: true,
                    centerPadding: '20px',
                    slidesToShow: 3,
                }
            }
        ]
    })
    // slider hero home
	$('.hero-slides').slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        accessibility: false,
		fade: true,
		autoplay : false,
		autoplaySpeed: 5500,
		speed: 1000,
		pauseOnFocus: false,
		pauseOnHover : false,
        arrows: true,
        dots: false,
    });

    //menus
    if(document.getElementsByClassName('js-menu-tab').length > 0){
        document.querySelectorAll(".js-menu-tab").forEach((btn) => {
            btn.addEventListener("click", (_) => {
            $(".js-menu-tab.active").removeClass("active");
            $(btn).addClass("active");
            $(".quad-menus__menu-content.active").removeClass("active");
            var tabNumber = $(btn).attr("data-menuid");
            var tabToOpen =
                ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass("active");
            $(".quad-menus__tabs-image.active").removeClass("active");
            var imgToOpen =
                ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass("active");
            $(".name-bg.active").removeClass("active");
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass("active");
            });
        });
    }

    if(document.getElementById('menuSelect')){
        document.querySelectorAll(".js-menu-option").forEach((btn) => {
            btn.addEventListener("click", (_) => {
            $(".js-menu-option.active").removeClass("active");
            $(btn).addClass("active");
            $(".quad-menus__menu-content.active").removeClass("active");
            var tabNumber = $(btn).attr("data-menuid");
            var tabToOpen =
                ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass("active");
            $(".quad-menus__tabs-image.active").removeClass("active");
            var imgToOpen =
                ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass("active");
            $(".name-bg.active").removeClass("active");
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass("active");
            });
        });
    }
    

})();